import React from 'react';
import { Copy, Check } from 'lucide-react';

const RoomCodeDisplay = ({ roomCode, copiedCode, copyRoomCode, participants, myChannel }) => {
  return (
    <div className="flex items-center gap-3">
      <div className="relative">
        <div className="w-12 h-12 rounded-xl bg-accent-secondary flex items-center justify-center shadow-lg">
          <span className="text-2xl text-white">📞</span>
        </div>
        <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full border-2 border-zinc-900 bg-emerald-500 animate-pulse">
          <div className="absolute inset-0 animate-ping bg-emerald-500/30 rounded-full"></div>
        </div>
      </div>
      <div>
        <div className="flex items-center gap-2">
          <div className="relative group">
            <div className="text-white font-mono font-bold text-lg bg-zinc-800/80 px-3 py-1.5 rounded-lg border border-white/10 backdrop-blur-sm">
              {roomCode}
            </div>
            <button
              onClick={copyRoomCode}
              className="absolute -right-2 -top-2 p-1.5 bg-gradient-to-br from-zinc-700 to-zinc-800 hover:from-zinc-600 hover:to-zinc-700 rounded-full transition-all duration-300 shadow-lg opacity-0 group-hover:opacity-100 group-hover:scale-110 active:scale-95"
            >
              {copiedCode ? (
                <Check className="w-3.5 h-3.5 text-green-400" />
              ) : (
                <Copy className="w-3.5 h-3.5 text-zinc-300" />
              )}
            </button>
          </div>
        </div>
        <div className="text-xs text-zinc-500 mt-1.5 flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
          <span>Share code to invite others</span>
        </div>
      </div>
    </div>
  );
};

export default RoomCodeDisplay;